module.exports = __webpack_public_path__ + "static/media/close-icon-white.c3ee4656.svg";